<template>
<div class="chapter">
<div class="inner_page">
<p class="dedi"><i>To my son,<br/>
  Michael Nicholas Dwyer,<br/>
  my fearless companion on many Seattle ghost hunts</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_9781589805170_Dedication.vue?3fe170f4